export default {
    WAITING: 'waiting',
    USER_SET_BASIC_INFO: 'USER::SET_BASIC_INFO',
    USER_GET_INFO: 'USER::GET_INFO',
    USER_GET_INFO_SUCCESS: 'USER::GET_INFO_SUCCESS',
    USER_CLEAN: 'USER::CLEAN'
};



// WEBPACK FOOTER //
// ./src/store/user/UserActionsEnums.js